import {h, Fragment} from "preact"
export default function Checkbox({ value, selected, onChange, className, count }) {
    return (
        <label className={`ns-checkbox ns-d-block ${className}`}>
            {value} 
            <input type="checkbox" checked={selected} onChange={onChange} />
            <span className="ns-checkmark" />
            <span class="ns-count" style="padding-left: 3px;">({count})</span>
        </label>
    )
}